import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIAdBlockState {
    get isAdblockActive() {
        if (UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (!this.isReady) return false;
        if (this.forcedAdblockActive) return true;
        return window['adsAreGreat'] == undefined;
    }
    setAdblockEnabledStatus(adblockEnabled) {
        this.forcedAdblockActive = adblockEnabled;
    }
    constructor(){
        this.isReady = false;
        this.forcedAdblockActive = false;
        const delay = 1000;
        setTimeout(()=>this.isReady = true, delay);
    }
}
